const state = {
  userInfo: {},
  info: JSON.parse(window.localStorage.getItem('userInfo')||'{}'),
  memberId:'',
  cardInfo:{},
  backbtn:false,//自助机需要用的返回按钮
}

const mutations = {
  SET_USER_INFO (state, info) {
    state.userInfo = info
  },
  
  SET_SIGN_INFO (state, info) {
    state.signInfo = info
  },
  ['user_info'](state,info){
    window.localStorage.setItem('info',JSON.stringify(info));
    state.info=info;
  },
  ['user_id'](state,id){
    state.memberId=id;
  },
  ['card_info'](state,info){
    state.cardInfo=info;
  },
  //自助机过来的,需要加返回按钮
  ['backbtn'](state,info){
    window.localStorage.setItem('backbtn',info);
    state.backbtn=info;
  },

}

const actions = {
  deleteUserinfo({commit, state},_data){//清除用户信息
    console.log(1)
    window.localStorage.clear();
    window.localStorage.clear();
    state.info={};

    console.log(window.localStorage.getItem('userInfo'))

  },
  setUserInfo({commit, state},_data){
    commit("SET_USER_INFO",_data)
  },

  setSignInfo({commit, state},_data){
    commit("SET_SIGN_INFO",_data)
  },
  // 获取用户id
  getUserId(context,id){
    context.commit('user_id',id);
  },
  //读取用户详情
  UserInfo(context,info){
    context.commit('user_info',info);
  },
   // 获取身份证信息
  IdCard(context,infoo){
    context.commit('card_info',infoo);
  },
  //判断是否从pc端来的
  backbtn(context,infoo){
    context.commit('backbtn',infoo);
  },

 
}

export default {
  // namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js